// src/components/click-to-claim-toast/click-to-claim-toast.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSToastFragment on EGDSToast {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query ClickToClaimToastQuery($context: ContextInput!, $offerCode: String!) {\n    clickToClaimToast(context: $context, offerCode: $offerCode) {\n      toast {\n        ...EGDSToastFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React2, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-toast/egds-toast.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkToast } from "uitk-react-toast";
var fragment = gql(_templateObject());
var EGDSToastMemoized = React.memo(function(_param) {
    var text = _param.data.text, props = _object_without_properties(_param, [
        "data"
    ]);
    return /* @__PURE__ */ React.createElement(UitkToast, _object_spread_props(_object_spread({}, props), {
        show: true
    }), text);
});
var EGDSToast = function(props) {
    return /* @__PURE__ */ React.createElement(EGDSToastMemoized, _object_spread({}, props));
};
EGDSToastMemoized.displayName = "EGDSToastMemoized";
EGDSToast.fragment = fragment;
EGDSToast.displayName = "EGDSToast";
// src/components/click-to-claim-toast/click-to-claim-toast.tsx
var __Query = gql2(_templateObject1(), EGDSToast.fragment);
var AUTO_HIDE_TIMER = 2e4;
var ClickToClaimToast = function() {
    var _data_clickToClaimToast;
    var offerCodeParamName = "offerCode";
    var history = useHistory();
    var searchParams = new URLSearchParams(history.location.search);
    var getOfferCodeValue = function() {
        return searchParams.get(offerCodeParamName) || "";
    };
    var replaceUrl = function() {
        if (searchParams.has(offerCodeParamName)) {
            searchParams.delete(offerCodeParamName);
            var hash = history.location.hash;
            var search = searchParams.toString();
            history.replace({
                hash: hash,
                search: search
            });
        }
    };
    var _useState = _sliced_to_array(useState(getOfferCodeValue()), 1), offerCode = _useState[0];
    useEffect(function() {
        return replaceUrl();
    });
    var context = useBexApi().context;
    var variables = {
        context: context,
        offerCode: offerCode
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: false
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var toast = data === null || data === void 0 ? void 0 : (_data_clickToClaimToast = data.clickToClaimToast) === null || _data_clickToClaimToast === void 0 ? void 0 : _data_clickToClaimToast.toast;
    if (offerCode && !loading && toast && !error) {
        return /* @__PURE__ */ React2.createElement(EGDSToast, {
            data: toast,
            autoHideTimer: AUTO_HIDE_TIMER
        });
    }
    return null;
};
ClickToClaimToast.displayName = "ClickToClaim-Toast";
export { ClickToClaimToast };
//# sourceMappingURL=index.js.map